[
  "A圈儿",
  "A圈兒",
  "一下儿",
  "一下兒",
  "一个劲儿",
  "一会儿",
  "一個勁兒",
  "一口气儿",
  "一口氣兒",
  "一古脑儿",
  "一古腦兒",
  "一块儿",
  "一塊兒",
  "一大早儿",
  "一大早兒",
  "一字儿",
  "一字兒",
  "一对儿",
  "一對兒",
  "一小阵儿",
  "一小陣兒",
  "一拨儿",
  "一撥兒",
  "一时半会儿",
  "一時半會兒",
  "一會兒",
  "一水儿",
  "一水兒",
  "一点儿",
  "一股脑儿",
  "一股腦兒",
  "一點兒",
  "万儿八千",
  "上边儿",
  "上邊兒",
  "上鉤兒",
  "上钩儿",
  "下边儿",
  "下邊兒",
  "不儿",
  "不儿道",
  "不兒",
  "不兒道",
  "不大离儿",
  "不大離兒",
  "不对劲儿",
  "不对碴儿",
  "不對勁兒",
  "不對碴兒",
  "不是味儿",
  "不是味兒",
  "不离儿",
  "不起眼儿",
  "不起眼兒",
  "不離兒",
  "东边儿",
  "两口儿",
  "两头儿",
  "两着儿",
  "严了眼儿",
  "个儿",
  "个头儿",
  "丫巴儿",
  "丫巴兒",
  "串門兒",
  "串门儿",
  "临月儿",
  "乐儿",
  "书皮儿",
  "书馆儿",
  "事儿",
  "事儿B",
  "事儿妈",
  "事兒",
  "事兒B",
  "事兒媽",
  "人儿",
  "人兒",
  "人尖儿",
  "人尖兒",
  "人情味儿",
  "人情味兒",
  "人緣兒",
  "人缘儿",
  "今儿",
  "今儿个",
  "今兒",
  "今兒個",
  "仙方儿",
  "仙方兒",
  "份儿",
  "份儿饭",
  "份兒",
  "份兒飯",
  "伊妹儿",
  "伊妹兒",
  "伊媚儿",
  "伊媚兒",
  "会儿",
  "估堆儿",
  "估堆兒",
  "使劲儿",
  "使勁兒",
  "來火兒",
  "俩钱儿",
  "倆錢兒",
  "個兒",
  "個頭兒",
  "倍儿",
  "倍儿棒",
  "倍兒",
  "倍兒棒",
  "倒座儿",
  "倒座兒",
  "倒背手儿",
  "倒背手兒",
  "倒过儿",
  "倒過兒",
  "倒霉蛋儿",
  "倒霉蛋兒",
  "借单儿",
  "借單兒",
  "借字儿",
  "借字兒",
  "做伴儿",
  "做伴兒",
  "做活儿",
  "做活兒",
  "傍家儿",
  "傍家兒",
  "傻大个儿",
  "傻大個兒",
  "傻帽儿",
  "傻帽兒",
  "像那么回事儿",
  "像那麽回事兒",
  "儿媳妇儿",
  "光棍儿",
  "光棍兒",
  "克蕾儿",
  "克蕾兒",
  "兒媳婦兒",
  "兜儿",
  "兜兒",
  "全须全尾儿",
  "全鬚全尾兒",
  "兩口兒",
  "兩著兒",
  "兩頭兒",
  "八哥儿",
  "八哥兒",
  "八字还没一撇儿",
  "八字還沒一撇兒",
  "公子哥儿",
  "公子哥兒",
  "冰棍儿",
  "冰棍兒",
  "准谱儿",
  "出圈儿",
  "出圈兒",
  "出尖儿",
  "出尖兒",
  "出摊儿",
  "出攤兒",
  "出臭子儿",
  "出臭子兒",
  "刨根儿",
  "刨根兒",
  "刺儿",
  "刺儿头",
  "刺儿李",
  "刺儿话",
  "刺兒",
  "刺兒李",
  "刺兒話",
  "刺兒頭",
  "前儿",
  "前兒",
  "前半天儿",
  "前半天兒",
  "前半晌儿",
  "前半晌兒",
  "前边儿",
  "前邊兒",
  "加劲儿",
  "加勁兒",
  "加塞儿",
  "加塞兒",
  "动嘴皮儿",
  "努劲儿",
  "努勁兒",
  "努嘴儿",
  "努嘴兒",
  "劲儿",
  "勁兒",
  "動嘴皮兒",
  "包乾兒",
  "包圆儿",
  "包圓兒",
  "包干儿",
  "包袱底儿",
  "包袱底兒",
  "包袱皮儿",
  "包袱皮兒",
  "北边儿",
  "北邊兒",
  "千儿八百",
  "千兒八百",
  "半分儿",
  "半分兒",
  "半开门儿",
  "半開門兒",
  "单个儿",
  "南边儿",
  "南邊兒",
  "占地儿",
  "占地兒",
  "卧果儿",
  "卸肩儿",
  "卸肩兒",
  "压根儿",
  "又要馬兒好，又要馬兒不吃草",
  "又要馬兒跑，又要馬兒不吃草",
  "又要马儿好，又要马儿不吃草",
  "又要马儿跑，又要马儿不吃草",
  "反面儿",
  "反面兒",
  "发小儿",
  "取灯儿",
  "取燈兒",
  "变样儿",
  "变法儿",
  "口哨儿",
  "可劲儿",
  "可勁兒",
  "右边儿",
  "右邊兒",
  "合轍兒",
  "合辙儿",
  "吊儿郎当",
  "吊兒郎當",
  "名儿",
  "名兒",
  "名牌儿",
  "名牌兒",
  "名角儿",
  "名角兒",
  "后儿",
  "后边儿",
  "后钩儿",
  "听墙根儿",
  "呆会儿",
  "呆會兒",
  "告儿",
  "告兒",
  "味儿",
  "味兒",
  "咖啡館兒",
  "咖啡馆儿",
  "咬人狗儿不露齿",
  "咬人狗兒不露齒",
  "咸丝丝儿",
  "咸津津儿",
  "哗儿哗儿",
  "哥们儿",
  "哥們兒",
  "哥儿",
  "哥兒",
  "哪儿",
  "哪儿的话",
  "哪儿跟哪儿",
  "哪兒",
  "哪兒的話",
  "哪兒跟哪兒",
  "哼儿哈儿",
  "哼兒哈兒",
  "唱高調兒",
  "唱高调儿",
  "單個兒",
  "喷嘴儿",
  "嗓子眼儿",
  "嗓子眼兒",
  "嗝儿屁",
  "嗝兒屁",
  "嘩兒嘩兒",
  "噴嘴兒",
  "嚴了眼兒",
  "嚼劲儿",
  "嚼勁兒",
  "回单儿",
  "回單兒",
  "土坎儿",
  "土坎兒",
  "在那儿",
  "在那兒",
  "地儿",
  "地兒",
  "场儿",
  "坎儿",
  "坎儿井",
  "坎兒",
  "坎兒井",
  "坎肩儿",
  "坎肩兒",
  "坏包儿",
  "块儿八毛",
  "坨儿",
  "坨兒",
  "垫底儿",
  "場兒",
  "塊兒八毛",
  "塔塔儿",
  "塔塔儿人",
  "塔塔兒",
  "塔塔兒人",
  "墊底兒",
  "墨水儿",
  "墨水兒",
  "壓根兒",
  "壞包兒",
  "壳儿",
  "外孙女儿",
  "外孫女兒",
  "外边儿",
  "外邊兒",
  "夜宵儿",
  "夜宵兒",
  "夜盆儿",
  "夜盆兒",
  "大个儿",
  "大伙儿",
  "大伙兒",
  "大個兒",
  "大家伙儿",
  "大家伙兒",
  "大气儿",
  "大氣兒",
  "大腕儿",
  "大腕兒",
  "天儿",
  "天兒",
  "天老儿",
  "天老兒",
  "头儿",
  "头儿脑儿",
  "头半天儿",
  "头箍儿",
  "头脸儿",
  "夹塞儿",
  "夹当儿",
  "夾塞兒",
  "夾當兒",
  "奔头儿",
  "奔頭兒",
  "套儿",
  "套兒",
  "套衫儿",
  "套衫兒",
  "女孩儿",
  "女孩兒",
  "奶嘴儿",
  "奶嘴兒",
  "好好儿",
  "好好兒",
  "好玩儿",
  "好玩兒",
  "姐们儿",
  "姐們兒",
  "娘儿们",
  "娘兒們",
  "媳妇儿",
  "媳婦兒",
  "子儿",
  "子兒",
  "字帖儿",
  "字帖兒",
  "孙女儿",
  "孩儿",
  "孩兒",
  "孫女兒",
  "宝贝儿",
  "家雀儿",
  "家雀兒",
  "宽心丸儿",
  "寬心丸兒",
  "寶貝兒",
  "对劲儿",
  "对味儿",
  "对工儿",
  "对心儿",
  "对茬儿",
  "對勁兒",
  "對味兒",
  "對工兒",
  "對心兒",
  "對茬兒",
  "小两口儿",
  "小伙儿",
  "小伙兒",
  "小偷儿",
  "小偷兒",
  "小兩口兒",
  "小孩儿",
  "小孩兒",
  "小心眼儿",
  "小心眼兒",
  "小抄儿",
  "小抄兒",
  "小摊儿",
  "小攤兒",
  "小日本儿",
  "小日本兒",
  "小时候儿",
  "小時候兒",
  "小白脸儿",
  "小白臉兒",
  "小菜儿",
  "小菜兒",
  "小辫儿",
  "小辮兒",
  "尜儿",
  "尜兒",
  "尿盆儿",
  "尿盆兒",
  "屁墩儿",
  "屁墩兒",
  "屁眼儿",
  "屁眼兒",
  "屁股蹲儿",
  "屁股蹲兒",
  "屄样儿",
  "屄樣兒",
  "居民点儿",
  "居民點兒",
  "屈戌儿",
  "屈戌兒",
  "左边儿",
  "左邊兒",
  "差一点儿",
  "差一點兒",
  "差不离儿",
  "差不離兒",
  "差点儿",
  "差點兒",
  "巴儿狗",
  "巴兒狗",
  "带儿",
  "帶兒",
  "帽箍儿",
  "帽箍兒",
  "干活儿",
  "年头儿",
  "年画儿",
  "年畫兒",
  "年頭兒",
  "幹活兒",
  "庄稼户儿",
  "庄稼活儿",
  "应名儿",
  "应景儿",
  "座儿",
  "座兒",
  "开花儿",
  "弓弦儿",
  "弓弦兒",
  "当儿",
  "当回事儿",
  "影儿",
  "影兒",
  "待会儿",
  "待會兒",
  "後兒",
  "後邊兒",
  "後鉤兒",
  "心眼儿",
  "心眼兒",
  "心窝儿",
  "心窩兒",
  "快板儿",
  "快板兒",
  "快点儿",
  "快點兒",
  "念想儿",
  "念想兒",
  "怔神儿",
  "怔神兒",
  "恐怖片儿",
  "恐怖片兒",
  "恶名儿",
  "情儿",
  "情兒",
  "惡名兒",
  "愣劲儿",
  "愣勁兒",
  "愣神儿",
  "愣神兒",
  "懂門兒",
  "懂门儿",
  "應名兒",
  "應景兒",
  "成方儿",
  "成方兒",
  "我这儿",
  "我這兒",
  "戳个儿",
  "戳份儿",
  "戳份兒",
  "戳個兒",
  "戳儿",
  "戳兒",
  "扑脸儿",
  "扒头儿",
  "扒頭兒",
  "打哈哈儿",
  "打哈哈兒",
  "打响鼻儿",
  "打哪儿指哪儿",
  "打哪兒指哪兒",
  "打嗝儿",
  "打嗝兒",
  "打挺儿",
  "打挺兒",
  "打旋儿",
  "打旋兒",
  "打盹儿",
  "打盹兒",
  "打短儿",
  "打短兒",
  "打趸儿",
  "打躉兒",
  "打響鼻兒",
  "打頓兒",
  "打顿儿",
  "扣眼儿",
  "扳不倒儿",
  "扳不倒兒",
  "扳指儿",
  "扳指兒",
  "扳本儿",
  "扳本兒",
  "找刺儿",
  "找刺兒",
  "找台阶儿",
  "找台階兒",
  "找碴儿",
  "找碴兒",
  "抄近儿",
  "抄近兒",
  "把儿",
  "把兒",
  "抓子儿",
  "抓子兒",
  "折刀儿",
  "折刀兒",
  "折过儿",
  "折過兒",
  "抠字眼儿",
  "抠门儿",
  "拉勾儿",
  "拉勾兒",
  "拉后钩儿",
  "拉後鉤兒",
  "拐弯儿",
  "拐彎兒",
  "拔尖儿",
  "拔尖兒",
  "拔火罐儿",
  "拔火罐兒",
  "拘挛儿",
  "拘攣兒",
  "挂钩儿",
  "挎兜儿",
  "挎兜兒",
  "挑头儿",
  "挑毛剔刺儿",
  "挑毛剔刺兒",
  "挑頭兒",
  "挨个儿",
  "挨個兒",
  "挨呲儿",
  "挨呲兒",
  "挨肩儿",
  "挨肩兒",
  "挨边儿",
  "挨邊兒",
  "挪窝儿",
  "挪窩兒",
  "换个儿",
  "捧角儿",
  "捧角兒",
  "掉价儿",
  "掉價兒",
  "掉点儿",
  "掉过儿",
  "掉過兒",
  "掉點兒",
  "掛鉤兒",
  "探头探脑儿",
  "探頭探腦兒",
  "提头儿",
  "提篮儿",
  "提籃兒",
  "提頭兒",
  "換個兒",
  "搞花样儿",
  "搞花樣兒",
  "搭把手儿",
  "搭把手兒",
  "搭茬儿",
  "搭茬兒",
  "摁扣儿",
  "摁扣兒",
  "摁釘兒",
  "摁钉儿",
  "摆设儿",
  "摆谱儿",
  "摊事儿",
  "摊儿",
  "摳字眼兒",
  "摳門兒",
  "撒欢儿",
  "撒歡兒",
  "撲臉兒",
  "擦黑儿",
  "擦黑兒",
  "擺設兒",
  "擺譜兒",
  "攀高枝儿",
  "攀高枝兒",
  "攤事兒",
  "攤兒",
  "敞开儿",
  "敞開兒",
  "散座儿",
  "散座兒",
  "斗趣儿",
  "料头儿",
  "料豆儿",
  "料豆兒",
  "料頭兒",
  "斜愣眼儿",
  "斜愣眼兒",
  "断片儿",
  "斷片兒",
  "旁边儿",
  "旁邊兒",
  "早早儿",
  "早早兒",
  "早点儿",
  "早班儿",
  "早班兒",
  "早點兒",
  "旮旯儿",
  "旮旯兒",
  "明儿",
  "明儿个",
  "明兒",
  "明兒個",
  "昨儿",
  "昨儿个",
  "昨兒",
  "昨兒個",
  "是味儿",
  "是味兒",
  "晕高儿",
  "晚半天儿",
  "晚半天兒",
  "暈高兒",
  "暗哨儿",
  "暗哨兒",
  "暗花儿",
  "暗花兒",
  "暗記兒",
  "暗记儿",
  "暗間兒",
  "暗间儿",
  "書皮兒",
  "書館兒",
  "替班儿",
  "替班兒",
  "替角儿",
  "替角兒",
  "會兒",
  "月头儿",
  "月頭兒",
  "有一点儿",
  "有一點兒",
  "有点儿",
  "有眼力見兒",
  "有眼力见儿",
  "有空儿",
  "有空兒",
  "有譜兒",
  "有谱儿",
  "有边儿",
  "有邊兒",
  "有點兒",
  "未知数儿",
  "未知數兒",
  "末儿",
  "末兒",
  "杂件儿",
  "杂和面儿",
  "杂拌儿",
  "杂牌儿",
  "来火儿",
  "東邊兒",
  "板儿爷",
  "板兒爺",
  "板擦儿",
  "板擦兒",
  "枕席儿",
  "枕席兒",
  "果仁儿",
  "果仁兒",
  "果料儿",
  "果料兒",
  "枪把儿",
  "枪杆儿",
  "样儿",
  "核儿",
  "核兒",
  "桌面儿",
  "桌面儿上",
  "桌面兒",
  "桌面兒上",
  "棒子面儿",
  "棒子麵兒",
  "榛仁儿",
  "榛仁兒",
  "槍把兒",
  "槍桿兒",
  "樂兒",
  "模特儿",
  "模特兒",
  "樣兒",
  "横竖劲儿",
  "橡子面儿",
  "橡子麵兒",
  "橫豎勁兒",
  "款儿",
  "款兒",
  "歌儿",
  "歌兒",
  "死劲儿",
  "死勁兒",
  "死心眼儿",
  "死心眼兒",
  "殼兒",
  "气不忿儿",
  "氣不忿兒",
  "水牛儿",
  "水牛兒",
  "水餃兒",
  "水饺儿",
  "汗褂儿",
  "汗褂兒",
  "汗褟儿",
  "汗褟兒",
  "沒事兒",
  "沒人味兒",
  "沒六兒",
  "沒勁兒",
  "沒法兒",
  "沒準兒",
  "沒溜兒",
  "沒空兒",
  "沒譜兒",
  "沒門兒",
  "没事儿",
  "没人味儿",
  "没六儿",
  "没准儿",
  "没劲儿",
  "没法儿",
  "没溜儿",
  "没空儿",
  "没谱儿",
  "没门儿",
  "沿儿",
  "沿兒",
  "沿条儿",
  "沿條兒",
  "沿边儿",
  "沿邊兒",
  "法儿",
  "法兒",
  "洋画儿",
  "洋畫兒",
  "洗发水儿",
  "洗髮水兒",
  "活儿",
  "活兒",
  "浑球儿",
  "消閒兒",
  "消闲儿",
  "消食儿",
  "消食兒",
  "混名儿",
  "混名兒",
  "混混儿",
  "混混兒",
  "混球儿",
  "混球兒",
  "渔钩儿",
  "渾球兒",
  "準譜兒",
  "溜边儿",
  "溜邊兒",
  "漁鉤兒",
  "火儿",
  "火兒",
  "炮儿局",
  "炮兒局",
  "炸土豆条儿",
  "炸土豆條兒",
  "点儿",
  "点儿背",
  "烘笼儿",
  "烘籠兒",
  "烟卷儿",
  "烟头儿",
  "煙捲兒",
  "煙頭兒",
  "熟道儿",
  "熟道兒",
  "熬头儿",
  "熬頭兒",
  "爆冷門兒",
  "爆冷门儿",
  "爆肚儿",
  "爆肚兒",
  "爪儿",
  "爪兒",
  "爪尖儿",
  "爪尖兒",
  "爷们儿",
  "爺們兒",
  "片儿",
  "片儿警",
  "片兒",
  "片兒警",
  "牙縫兒",
  "牙缝儿",
  "牻牛儿苗科",
  "牻牛兒苗科",
  "犟劲儿",
  "犟勁兒",
  "独院儿",
  "猛劲儿",
  "猛勁兒",
  "猜謎兒",
  "猜谜儿",
  "猫眼儿",
  "猴儿精",
  "猴兒精",
  "獨院兒",
  "玩儿",
  "玩儿不转",
  "玩儿命",
  "玩儿坏",
  "玩儿完",
  "玩儿得转",
  "玩儿票",
  "玩儿花招",
  "玩兒",
  "玩兒不轉",
  "玩兒命",
  "玩兒壞",
  "玩兒完",
  "玩兒得轉",
  "玩兒票",
  "玩兒花招",
  "玩意儿",
  "玩意兒",
  "玩艺儿",
  "玩藝兒",
  "班輩兒",
  "班辈儿",
  "理儿",
  "理兒",
  "瓤儿",
  "瓤兒",
  "电马儿",
  "男孩儿",
  "男孩兒",
  "画儿",
  "留心眼儿",
  "留心眼兒",
  "畫兒",
  "當兒",
  "當回事兒",
  "病包儿",
  "病包兒",
  "痰盂儿",
  "痰盂兒",
  "瘾头儿",
  "癮頭兒",
  "白乾兒",
  "白干儿",
  "白班儿",
  "白班兒",
  "白眼珠儿",
  "白眼珠兒",
  "白面儿",
  "白麵兒",
  "皮儿",
  "皮兒",
  "盖儿",
  "盖帽儿",
  "省劲儿",
  "省勁兒",
  "看人下菜碟儿",
  "看人下菜碟兒",
  "看得过儿",
  "看得過兒",
  "眼力見兒",
  "眼力见儿",
  "眼珠儿",
  "眼珠兒",
  "着劲儿",
  "着边儿",
  "着道儿",
  "矮个儿",
  "矮個兒",
  "石子儿",
  "石子兒",
  "砚水壶儿",
  "破題兒",
  "破題兒第一遭",
  "破题儿",
  "破题儿第一遭",
  "硯水壺兒",
  "碎块儿",
  "碎塊兒",
  "碑座儿",
  "碑座兒",
  "碰瓷儿",
  "碰瓷兒",
  "礤床儿",
  "礤床兒",
  "票友儿",
  "票友兒",
  "离谱儿",
  "空儿",
  "空兒",
  "空心儿",
  "空心兒",
  "窍门儿",
  "窑姐儿",
  "窝脖儿",
  "窩脖兒",
  "窯姐兒",
  "竅門兒",
  "竹箍儿",
  "竹箍兒",
  "笑脸儿",
  "笑臉兒",
  "笑話兒",
  "笑话儿",
  "等一下儿",
  "等一下兒",
  "等一会儿",
  "等一會兒",
  "简帖儿",
  "箍節兒",
  "箍节儿",
  "節骨眼兒",
  "範兒",
  "簡帖兒",
  "紅箍兒",
  "紋絲兒",
  "紋縷兒",
  "納悶兒",
  "紙煤兒",
  "紙馬兒",
  "絕門兒",
  "繚邊兒",
  "繞彎兒",
  "繞彎子兒",
  "繞遠兒",
  "红箍儿",
  "纳闷儿",
  "纸煤儿",
  "纸马儿",
  "纹丝儿",
  "纹缕儿",
  "绕弯儿",
  "绕弯子儿",
  "绕远儿",
  "绝门儿",
  "缭边儿",
  "缺心眼儿",
  "缺心眼兒",
  "罄身儿",
  "罄身兒",
  "罗圈儿",
  "罗圈儿揖",
  "罗锅儿",
  "羅圈兒",
  "羅圈兒揖",
  "羅鍋兒",
  "翻篇儿",
  "翻篇兒",
  "老两口儿",
  "老伴儿",
  "老伴兒",
  "老兩口兒",
  "老头儿",
  "老客儿",
  "老客兒",
  "老帽儿",
  "老帽兒",
  "老頭兒",
  "耳朵眼儿",
  "耳朵眼兒",
  "聊天儿",
  "聊天兒",
  "聽牆根兒",
  "肚儿",
  "肚兒",
  "胆儿",
  "背影儿",
  "背影兒",
  "胖墩儿",
  "胖墩兒",
  "胡同儿",
  "胡同兒",
  "胡琴儿",
  "胡琴兒",
  "胳臂箍儿",
  "胳臂箍兒",
  "胳臂肘儿",
  "胳臂肘兒",
  "脑儿",
  "脑瓜儿",
  "脑瓢儿",
  "脖梗儿",
  "脖梗兒",
  "脖頸兒",
  "脖颈儿",
  "脸盘儿",
  "脸蛋儿",
  "腕儿",
  "腕兒",
  "腦兒",
  "腦瓜兒",
  "腦瓢兒",
  "膽兒",
  "臉盤兒",
  "臉蛋兒",
  "臥果兒",
  "臨月兒",
  "自个儿",
  "自個兒",
  "自各儿",
  "自各兒",
  "臭子儿",
  "臭子兒",
  "节骨眼儿",
  "花边儿",
  "花邊兒",
  "苦不唧儿",
  "苦不唧兒",
  "苦活儿",
  "苦活兒",
  "范儿",
  "茶叶末儿",
  "茶葉末兒",
  "茶館兒",
  "茶馆儿",
  "草字头儿",
  "草字頭兒",
  "药方儿",
  "药水儿",
  "莊稼戶兒",
  "莊稼活兒",
  "萬兒八千",
  "著勁兒",
  "著道兒",
  "著邊兒",
  "葡萄乾兒",
  "葡萄干儿",
  "蓋兒",
  "蓋帽兒",
  "蔫儿",
  "蔫儿坏",
  "蔫兒",
  "蔫兒壞",
  "藏猫儿",
  "藏貓兒",
  "藥方兒",
  "藥水兒",
  "虫儿",
  "蛋卷儿",
  "蛋卷兒",
  "蛐蛐儿",
  "蛐蛐兒",
  "蝈蝈儿",
  "蟈蟈兒",
  "蟲兒",
  "衣裳鈎兒",
  "衣裳钩儿",
  "衣鉤兒",
  "衣钩儿",
  "袖筒儿",
  "袖筒兒",
  "被窝儿",
  "被窩兒",
  "裡邊兒",
  "褪套儿",
  "褪套兒",
  "西边儿",
  "西邊兒",
  "要样儿",
  "要樣兒",
  "討底兒",
  "試手兒",
  "話茬兒",
  "認人兒",
  "認死扣兒",
  "認死理兒",
  "說著玩兒",
  "調門兒",
  "謎兒",
  "變樣兒",
  "變法兒",
  "认人儿",
  "认死扣儿",
  "认死理儿",
  "讨底儿",
  "试手儿",
  "话茬儿",
  "说着玩儿",
  "调门儿",
  "谜儿",
  "豆角儿",
  "豆角兒",
  "貓眼兒",
  "貝殼兒",
  "貪玩兒",
  "費勁兒",
  "贝壳儿",
  "贪玩儿",
  "费劲儿",
  "走味儿",
  "走味兒",
  "走形儿",
  "走形兒",
  "走样儿",
  "走樣兒",
  "走神儿",
  "走神兒",
  "走背字儿",
  "走背字兒",
  "赶明儿",
  "起名儿",
  "起名兒",
  "起小儿",
  "起小兒",
  "趁早儿",
  "趁早兒",
  "趕明兒",
  "趿拉儿",
  "趿拉兒",
  "跑味儿",
  "跑味兒",
  "跑堂儿的",
  "跑堂兒的",
  "跑神儿",
  "跑神兒",
  "跑腿儿",
  "跑腿兒",
  "蹦儿",
  "蹦兒",
  "蹦蹦儿车",
  "蹦蹦兒車",
  "蹦高儿",
  "蹦高兒",
  "身板儿",
  "身板兒",
  "車份兒",
  "軟泥兒",
  "較勁兒",
  "較真兒",
  "輩兒",
  "轉軸兒",
  "轉鈴兒",
  "车份儿",
  "转轴儿",
  "转铃儿",
  "软泥儿",
  "较劲儿",
  "较真儿",
  "辈儿",
  "边儿",
  "过一会儿",
  "过节儿",
  "迎头儿",
  "迎頭兒",
  "这会儿",
  "这儿",
  "这早晚儿",
  "这边儿",
  "这阵儿",
  "追根究底儿",
  "追根究底兒",
  "逗笑儿",
  "逗笑兒",
  "逗趣儿",
  "逗趣兒",
  "這兒",
  "這早晚兒",
  "這會兒",
  "這邊兒",
  "這陣兒",
  "過一會兒",
  "過節兒",
  "遛弯儿",
  "遛彎兒",
  "邊兒",
  "那会儿",
  "那儿",
  "那兒",
  "那會兒",
  "那話兒",
  "那话儿",
  "邷么儿",
  "邷麼兒",
  "配对儿",
  "配對兒",
  "酒令儿",
  "酒令兒",
  "酒館兒",
  "酒馆儿",
  "醋劲儿",
  "醋勁兒",
  "里边儿",
  "重活儿",
  "重活兒",
  "重眼皮儿",
  "重眼皮兒",
  "釕銱兒",
  "針尖兒對麥芒兒",
  "針箍兒",
  "針線活兒",
  "釣鉤兒",
  "釦眼兒",
  "鉚勁兒",
  "鉚足勁兒",
  "鉤兒",
  "鋪蓋卷兒",
  "錢串兒",
  "鐵哥們兒",
  "鐵鈎兒",
  "针尖儿对麦芒儿",
  "针箍儿",
  "针线活儿",
  "钌铞儿",
  "钓钩儿",
  "钩儿",
  "钱串儿",
  "铁哥们儿",
  "铁钩儿",
  "铆劲儿",
  "铆足劲儿",
  "铺盖卷儿",
  "門坎兒",
  "閃亮兒",
  "開花兒",
  "门坎儿",
  "闪亮儿",
  "闹着玩儿",
  "阿物儿",
  "阿物兒",
  "隐身草儿",
  "隱身草兒",
  "雜件兒",
  "雜和麵兒",
  "雜拌兒",
  "雜牌兒",
  "雞子兒",
  "雞蛋殼兒",
  "離譜兒",
  "零杂儿",
  "零雜兒",
  "電馬兒",
  "露餡兒",
  "露馅儿",
  "面人儿",
  "面儿",
  "面兒",
  "面条儿",
  "頂尖兒",
  "頂牛兒",
  "順嘴兒",
  "順手兒",
  "頭兒",
  "頭兒腦兒",
  "頭半天兒",
  "頭箍兒",
  "頭臉兒",
  "顛兒",
  "顛兒丫子",
  "顛兒面",
  "顶尖儿",
  "顶牛儿",
  "顺嘴儿",
  "顺手儿",
  "颠儿",
  "颠儿丫子",
  "颠儿面",
  "飯館兒",
  "飽嗝兒",
  "餡兒",
  "餡兒餅",
  "饭馆儿",
  "饱嗝儿",
  "馅儿",
  "馅儿饼",
  "馬路沿兒",
  "马路沿儿",
  "骨头节儿",
  "骨頭節兒",
  "高高手儿",
  "高高手兒",
  "髮小兒",
  "鬥趣兒",
  "鬧著玩兒",
  "魚鉤兒",
  "鱼钩儿",
  "鳥兒",
  "鴨子兒",
  "鵪鶉餶飿兒",
  "鸟儿",
  "鸡子儿",
  "鸡蛋壳儿",
  "鸭子儿",
  "鹌鹑馉饳儿",
  "鹹津津兒",
  "鹹絲絲兒",
  "麵人兒",
  "麵條兒",
  "黏儿",
  "黏兒",
  "點兒",
  "點兒背",
  "鼻儿",
  "鼻兒",
  "鼻牛儿",
  "鼻牛兒",
  "齊打夯兒地",
  "齊眉穗兒",
  "齐打夯儿地",
  "齐眉穗儿"
]
